/* eslint-disable */
import { auth } from '@/plugins/auth/firebase.js'
import Cookie from 'js-cookie'
import JWTDecode from 'jwt-decode'
import Vue from 'vue'
import * as functions from "../payment/functions";
import * as firebase from "firebase";
import axios from 'axios'
import * as vars from '@/vars.json'
import moment from 'moment'

export const transactions = {
    namespaced: true,
    state: {
        criteria: '',
        transactions: null,
        sales: null,
        orders: null,
        requests: null,
        returns: null,
        expenses: null,
        purchases: null,
        transfers: null,
        addInventory: null,
        currentItem: {},
        currentType: 'sales',
        isLoading: false,
        currentShop: {},
        currentRequest: {},
        summaries: null,
        change_inventory: null
    },
    mutations: {
        SET_CURRENT_REQUEST (state, payload){
          state.currentRequest = payload
        },
        SET_FILTER_CRITERIA (state, payload) {
            state.criteria = payload
        },
        SET_CURRENT_TYPE (state, payload) {
            state.currentType = payload
        },
        SET_CURRENT_SHOP (state, payload) {
            state.currentShop = payload
        },
        SET_PURCHASES_LIST (state, payload) {
            // console.log('se pobla lista de compras', payload)
            state.purchases = payload
        },
        SET_TRANSFERS_LIST (state, payload) {
            // console.log('se pobla lista de transferencias', payload)
            state.transfers = payload
        },
        SET_SALES_LIST (state, payload) {
            // console.log('se pobla lista de ventas', payload)
            state.sales = payload
        },
        SET_ORDERS_LIST (state, payload) {
          // console.log('se pobla lista de ventas', payload)
          state.orders = payload
        },
        SET_REQUESTS_LIST (state, payload) {
          state.requests = payload
        },
        SET_TRANSACTION_lIST (state, payload) {
            // console.log('se pobla lista global', payload)
            state.transactions = payload
        },
        CLEAR_TRANSACTIONS (state) {
            // console.log('se elimina las transactions')
            state.transactions = null
            state.sales = null
            state.purchases = null
            state.transfers = null
            // console.log(state.transactions)
            // console.log(state.sales)
            // console.log(state.purchases)
            // console.log(state.transfers)
        },
        SET_LOADING (state, payload) {
            state.isLoading = payload
        },
        SET_CURRENT_ITEM (state, payload) {
            state.currentItem = payload
        },
        SET_RETURNS_LIST (state, payload) {
            // console.log('se pobla lista de ventas', payload)
            state.returns = payload
        },
        SET_EXPENSES_LIST (state, payload) {
            // console.log('se pobla lista de gastos', payload)
            state.expenses = payload
        },
        SET_ADD_INVENTORY_LIST (state, payload) {
            // console.log('se pobla lista de gastos', payload)
            state.addInventory = payload
        },
        SET_SUMMARY_LIST (state, payload) {
            state.summaries = payload
        },
        SET_CHANGE_INVENTORY_LIST (state, payload) {
            state.change_inventory = payload
        },
    },

    actions: {
      //Esta accion recorre todas las transacciones de venta, luego remplaza lo que hay en 'location_from', por solo el id y el nombre de la tienda
      getItem({commit, state, rootState}, payload) {
        return new Promise(async (resolve, reject) => { 
            let userId = ''
            let type = payload[0]
            let refNumber = payload[1]
            // console.log(payload)
            if(rootState.users.user.adminUid){
                userId = rootState.users.user.adminUid
            }else{
                userId = rootState.users.user.uid
            }

            let path = `users/${userId}/transactions/${type}`
            const fireDB = firebase.database().ref().child(path).orderByChild('reference_number').equalTo(refNumber)
            fireDB.once('value', await function (snapshot) {
                // console.log(snapshot.val())
                commit('SET_CURRENT_REQUEST', snapshot.val())
                resolve()
            })
        })
      },
      async optimizeTransactions({ commit, state, rootState }, type){
        let userId = ''
        if(rootState.users.user.adminUid){
            userId = rootState.users.user.adminUid
        }else{
            userId = rootState.users.user.uid
        }
        let path = `users/${userId}/transactions/${type}`
        const fireDB = firebase.database().ref().child(path)
         fireDB.once('value',
           await function (snapshot) {
            snapshot.forEach(function(child) {
              // console.log(child.val())
              if(!child.val().reference_number){
                child.ref.update({
                  'reference_number': Vue.moment(child.val().time).valueOf() ,
                });
              }
              if(child.val().location_from) {
                child.ref.update({
                  'location_from': {
                    'id': child.val().location_from.id,
                    'name': child.val().location_from.name,
                  },
                });
              }
              if(child.val().location_to){
                child.ref.update({
                  'location_to': {
                    'id': child.val().location_to.id,
                    'name': child.val().location_to.name,
                  },
                });
              }


            });
          })

      },

        async clearTransactions ({ commit }) {
            await commit('CLEAR_TRANSACTIONS')
        },
        setFilterCriteria ({ commit }, payload) {
            commit('SET_FILTER_CRITERIA', payload)
        },
        setCurrentShop ({ commit }, payload) {
            commit('SET_CURRENT_SHOP', payload)
        },
        clearCurrentShop ({ commit }) {
            commit('SET_CURRENT_SHOP', null)
        },
        loadLogTotals ({commit, state, rootState, dispatch}, payload) {
            return new Promise(async (resolve, reject) => {
                let userId = ''
                if(rootState.users.user.adminUid) userId = rootState.users.user.adminUid
                else userId = rootState.users.user.uid
                await axios.post(vars.url + '/getTransactionsTotals', {data: payload, userId: userId}).then((response) => {
                    resolve(response.data)
                }).catch((error) => {
                    reject(error)
                })
            })
        },
        loadLog ({ commit, state, rootState, dispatch }, payload) {
            // console.log(payload)
            return new Promise(async (resolve, reject) => {
                commit('SET_LOADING', true)
                let userId = ''
                if(rootState.users.user.adminUid){
                    userId = rootState.users.user.adminUid
                }else{
                    userId = rootState.users.user.uid
                }
                let loadCommit
                const type = payload[0]
                commit('SET_CURRENT_TYPE', type)

                switch (type) {
                    case 'purchases':
                        loadCommit = 'SET_PURCHASES_LIST'
                        break
                    case 'sales':
                        loadCommit = 'SET_SALES_LIST'
                        break
                    case 'orders':
                      loadCommit = 'SET_ORDERS_LIST'
                      break
                    case 'requests':
                      loadCommit = 'SET_REQUESTS_LIST'
                      break
                    case 'transfers':
                        loadCommit = 'SET_TRANSFERS_LIST'
                        break
                    case 'returns':
                        loadCommit = 'SET_RETURNS_LIST'
                    break
                    case 'expenses':
                        loadCommit = 'SET_EXPENSES_LIST'
                    break
                    case 'add-inventory':
                        loadCommit = 'SET_ADD_INVENTORY_LIST'
                    break
                    case 'change_inventory':
                        loadCommit = 'SET_CHANGE_INVENTORY_LIST'
                    break
                    case 'all':
                        loadCommit = 'SET_TRANSACTION_lIST'
                        break
                }
                commit(loadCommit, null)
                await axios.post(vars.url + '/getTransactionLog', {data: payload, userId: userId}).then((response) => {
                    commit('SET_LOADING', false)
                    if (loadCommit === 'SET_ORDERS_LIST') {
                        const ordersResponse = response.data
                        const orders = []
                        ordersResponse.forEach(element => {
                            // console.log(element, 'the orders')
                            if (element.method === "Mercado pago" && element.mp && !element.mp.unpaid) {
                                orders.push(element)
                            } else if (element.method !== "Mercado pago") {
                                orders.push(element)
                            }
                        });
                        commit(loadCommit, orders)
                        resolve()
                    } else {
                        commit(loadCommit, response.data)
                        resolve()
                    }
                }).catch((error) => {
                  reject(error)
                })
            })
        },
        loadLogPagination ({ commit, state, rootState, dispatch }, payload) {
            return new Promise(async (resolve, reject) => {
                let userId = ''
                if(rootState.users.user.adminUid) userId = rootState.users.user.adminUid
                else userId = rootState.users.user.uid

                let loadCommit
                let transactions 
                switch (payload.type) {
                    case 'purchases':
                        loadCommit = 'SET_PURCHASES_LIST'
                        transactions = state.purchases
                    break
                    case 'sales':
                        loadCommit = 'SET_SALES_LIST'
                        transactions = state.sales
                    break
                }
                await axios.post(vars.url + '/getTransactionLogPagination', {data: payload, userId: userId}).then((response) => {
                    commit(loadCommit, transactions.concat(response.data))
                    resolve(response.data)
                }).catch((error) => {
                  reject(error)
                })
            })
        },
        loadLogSummary ({commit, rootState}) {
            return new Promise(async (resolve, reject) => {
                commit('SET_LOADING', true)
                let userId = ''
                if(rootState.users.user.adminUid){
                    userId = rootState.users.user.adminUid
                }else{
                    userId = rootState.users.user.uid
                }
                let loadCommit = 'SET_SUMMARY_LIST'
                let path = `users/${userId}/reports/`
                const fireDB = firebase.database().ref().child(path).orderByChild('time')
                let reports = []
                await fireDB.once('value', async (snapshots) => {
                    if (snapshots.exists) {
                        for await (const snapshot of Object.values(snapshots.val())) {
                            let data = snapshot
                            data.time = moment(data.time).format('DD-MM-YYYY')
                            reports.push(data)
                        }
                    }
                })
                commit(loadCommit, reports)
                commit('SET_LOADING', false)
                resolve()
            })
        },
        async sendBill ({ commit, state, rootState }, payload) {
            // console.log(payload)
            commit('SET_LOADING', true)
            return new Promise(async (resolve, reject) => {
                let userId = ''
                if(rootState.users.user.adminUid){
                    userId = rootState.users.user.adminUid
                }else{
                    userId = rootState.users.user.uid
                }
                payload.reference_number = await Vue.moment().valueOf();
                switch(payload.type){
                    default: 
                        const transactionKey = firebase.database().ref().child(`users/${userId}/transactions/${payload.type}`).push().key
                        payload.id = transactionKey
                        await firebase.database().ref().child(`users/${userId}/transactions/${payload.type}/${transactionKey}`).update(payload).then(function () {
                            setTimeout(function () {
                                commit('SET_LOADING', false)
                                resolve()
                            }, 500)
                        })
                    break;
                }
            })
            /* const transactionKey = firebase.database().ref().child(`users/${userId}/transactions/${payload.type}`).push().key
            let userId = ''
            if(rootState.users.user.adminUid){
                userId = rootState.users.user.adminUid
            }else{
                userId = rootState.users.user.uid
            }
            commit('SET_LOADING', true)
            /* axios.post(vars.url2 + '/createSale', {data: payload, userId: userId}).then((response) => {
                commit('SET_LOADING', false)
            }).catch((error) => {
                // console.log(error, 'error enviando ' + payload.type)
            })
            const transactionKey = firebase.database().ref().child(`users/${userId}/transactions/${payload.type}`).push().key
            payload.id = transactionKey
            payload.reference_number= await Vue.moment().valueOf();
            await firebase.database().ref().child(`users/${userId}/transactions/${payload.type}/${transactionKey}`).update(payload).then(function () {
                setTimeout(function () {
                    commit('SET_LOADING', false)
                }, 500)

            }) */
        },
        async sendLog ({ commit, state, rootState }, payload) {
            return new Promise(async (resolve, reject) => {
                let userId = ''
                if(rootState.users.user.adminUid){
                    userId = rootState.users.user.adminUid
                }else{
                    userId = rootState.users.user.uid
                }
                const key = firebase.database().ref().child(`users/${userId}/transactions/logs`).push().key
                let updates = {}
                updates[`users/${userId}/transactions/logs/${key}`] = payload
                firebase.database().ref().update(updates)
            })
        },
        async updateBill ({ commit, state, rootState }, payload) {
            commit('SET_LOADING', true)
            const vm = this
            let userId = ''
            if(rootState.users.user.adminUid){
                userId = rootState.users.user.adminUid
            }else{
                userId = rootState.users.user.uid
            }
            const itemData = payload
            // console.log(itemData)
            await firebase.database().ref(`users/${userId}/transactions/${itemData.type}/${itemData.id}`).update(itemData).then(function () {
                    // updated!
                    commit('SET_LOADING', false)
                },
            ).catch(function (err) {
                commit('SET_LOADING', false)
                throw err
            })
        },
        async updateReturn ({ commit, state, rootState }, payload) {
            commit('SET_LOADING', true)
            const vm = this
            let userId = ''
            if(rootState.users.user.adminUid){
                userId = rootState.users.user.adminUid
            }else{
                userId = rootState.users.user.uid
            }
            payload.status = 'approved'
            const itemData = payload
            await firebase.database().ref(`users/${userId}/transactions/returns/${itemData.id}`).update(itemData).then(function () {
                    // updated!
                    commit('SET_LOADING', false)
                },
            ).catch(function (err) {
                commit('SET_LOADING', false)
                throw err
            })
        },
        async deleteBill({ commit, state, rootState }, payload) {
            // console.log(payload)
            let userId = ''
            if(rootState.users.user.adminUid){
                userId = rootState.users.user.adminUid
            }else{
                userId = rootState.users.user.uid
            }
            commit('SET_LOADING', true)
            await firebase.database().ref().child(`users/${userId}/transactions/${payload.type}/${payload.id}`).remove().then(function () {
                commit('SET_LOADING', false)
            }).catch(function(error){
                // console.log(error)
                commit('SET_LOADING', false)
            })
        },
        updateStatusOrder ({ state, dispatch }, data) {
            return new Promise((resolve, reject) => {
            if (data.banClientAdmin) {
                if (data.sendLimitWarning) {
                firebase.database().ref(`users/${data.idUser}/transactions/orders/${data.idOrder}`).update(
                    {
                    status: data.statusOrder,
                    sendLimitWarning: true,
                    limitWarning: data.limitWarning ,
                    maxAmountSale: data.maxAmountSale,
                    }
                    ).then((res) => {
                    resolve(res)
                }).catch((err) => {
                    dispatch('users/showErrorSessionExpired', null, {root:true})
                    reject(err)
                })
                } else {
                firebase.database().ref(`users/${data.idUser}/transactions/orders/${data.idOrder}/status`).set(
                    data.statusOrder).then((res) => {
                    resolve(res)
                }).catch((err) => {
                    dispatch('users/showErrorSessionExpired', null, {root:true})
                    reject(err)
                })
                }
                
            } else {
                firebase.database().ref(`users/${data.idUser}/transactions/requests/${data.idOrder}/status`).set(
                data.statusOrder).then((res) => {
                resolve(res)
                }).catch((err) => {
                    dispatch('users/showErrorSessionExpired', null, {root:true})
                    reject(err)
                })
            }
            })
        },
        cancelItem ({ commit, state, rootState }, data) {
            return new Promise((resolve, reject) => {
                let userId = ''
                if(rootState.users.user.adminUid){
                    userId = rootState.users.user.adminUid
                }else{
                    userId = rootState.users.user.uid
                }
                axios.post(vars.url + '/cancelTransaction', {data: data, userId: userId}).then((response) => {
                  resolve(response.data)
                }).catch((error) => {
                  reject(error)
                })
            })
        },
        resendPurchase ({ commit, state, rootState }, payload) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true)
                let userId = ''
                if(rootState.users.user.adminUid){
                    userId = rootState.users.user.adminUid
                }else{
                    userId = rootState.users.user.uid
                }
                const data = {
                    ...payload,
                    uid: userId,
                }
                // console.log(data)
                let path = '/resendPurchase'
                if (payload.type === 'sales') {
                    path = '/resendSales'
                } else if (payload.type === 'transfers') {
                    path = '/resendTransfers'
                } else if (payload.type === 'returns') {
                    path = '/resendReturn'
                } else if (payload.type === 'add-inventory') {
                    path = '/resendAddInventory'
                }
                axios.post(vars.url + path, {data}).then((response) => {
                  commit('SET_LOADING', false)
                  resolve(response.data)
                }).catch((error) => {
                  commit('SET_LOADING', false)
                  reject(error)
                })
            })
        },
    },
    getters: {

        getCurrentType: (state, getters) => {
            return state.currentType
        },
        getLog (state, rootGetters) {
            let transactions

            const type = state.currentType
            switch (type) {
                case 'sales':
                    transactions = state.sales
                    break
                case 'purchases':
                    transactions = state.purchases
                    break
                case 'transfers':
                    transactions = state.transfers
                    break
                case 'returns':
                    transactions = state.returns
                    break
                case 'expenses':
                    transactions = state.expenses
                    break
                case 'all':
                    transactions = [...state.sales, ...state.purchases, ...state.transfers]
                    break
            }

            if (state.criteria !== '') {
                return transactions.filter((el) => {
                    if (el.items) {
                        for (let i = 0; i < el.items.length; i++) {
                            if (el.items[i].name.includes(state.criteria)) {
                                return true
                                break
                            }
                        }
                    }
                })
            } else { return transactions }
        },

         getTransactionsTotal: (state, getters) => {
            let total = 0
            if (getters.getLog) {
                const list = getters.getLog || {}
                list.forEach(element => {
                    // if( Vue.moment().isSame(element.time, state.currentDateFilter))
                    total += +element.total
                })
                return total
            }
            return 0
        },
        getRevenueTotal: (state, getters) => {
            let total = 0
            if (getters.getLog) {
                const list = getters.getLog || {}
                list.forEach(element => {
                    if (element.items) {
                        element.items.forEach(item => {
                            if (item.purchase) {
                                total += (+item.price - +item.purchase) * +item.amount
                            }
                        })
                    }
                })
                return total
            }
            return 0
        },
        getAllTransactions (state) {
            return state.transactions
        },
        getTransactionType ({ state }, type) {
            switch (type) {
                case 'all':
                    return state.transactions
                    break
                case 'sales':
                    return state.sales
                    break
                case 'purchases':
                    return state.purchases
                    break
                case 'transfers':
                    return state.transfers
                    break
                case 'returns':
                    return state.returns
                    break
                case 'expenses':
                    return state.expenses
                    break
            }
        },
        getPurchases (state) {
            return state.purchases
        },
        getProductLog (state) {
            const productLog = []
            let transactions

            switch (state.currentType) {
                case 'sales':
                    transactions = state.sales
                    break
                case 'purchases':
                    transactions = state.purchases
                    break
                case 'transfers':
                    transactions = state.transfers
                    break
                case 'returns':
                    transactions = state.returns
                    break
                case 'expenses':
                    transactions = state.expenses
                    break
                case 'all':
                    transactions = [...state.sales, ...state.purchases, ...state.transfers]
                    break
            }

            try {
                const log = transactions.filter((el) => {
                    for (let i = 0; i < el.items.length; i++) {
                        if (el.items[i].name.includes(state.currentItem.name)) {
                            return true
                            break
                        }
                    }
                })

                log.forEach(item => {
                    item.items.forEach(el => {
                        if (el.name.includes(state.currentItem.name)) {
                            productLog.push(
                                {
                                    location: item.location,
                                    name: el.name,
                                    time: item.time,
                                    type: item.type,
                                    amount: +el.amount,
                                    purchase: +el.purchase,
                                    price: +el.price,
                                    total: +el.price * el.amount | 0,
                                    utility: (+el.price - +el.purchase) * 100 / +el.price,
                                },
                            )
                        }
                    })
                })
                // console.log(log)
                return productLog
            } catch (err) {
                // console.log(err)
                //
            }
        },

        getItems (state) {
            return state.shops_list
        },
        getCurrentItem (state) {
            return state.currentItem
        },
        getLoading (state) {
            return state.isLoading
        },
        getChangeInventory (state) {
            return state.change_inventory
        },
    },

}
